import { defineMessages } from 'react-intl'

export default defineMessages({
    versionAddSuccess: {
        id: 'containers.AuditionScopePage.components.AddVersion.versionAddSuccess',
        defaultMessage: 'Version added',
    },
    titleAudition: {
        id: 'containers.AuditionScopePage.components.AddVersion.titleAudition',
        defaultMessage: 'Audition details',
    },
    selectLanguageLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.selectLanguageLabel',
        defaultMessage: 'Language',
    },
    inputPriceLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.inputPriceLabel',
        defaultMessage: 'Price',
    },
    selectPriceCurrencyLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.selectPriceCurrencyLabel',
        defaultMessage: 'Currency',
    },
    selectSupplierLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.selectSupplierLabel',
        defaultMessage: 'Supplier',
    },
    inputCostLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.inputCostLabel',
        defaultMessage: 'Cost',
    },
    selectCostCurrencyLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.selectCostCurrencyLabel',
        defaultMessage: 'Currency',
    },
    titleLiveSession: {
        id: 'containers.AuditionScopePage.components.AddVersion.titleLiveSession',
        defaultMessage: 'LiveSession details',
    },
    createLiveSessionSwitch: {
        id: 'containers.AuditionScopePage.components.AddVersion.createLiveSessionSwitch',
        defaultMessage: 'Create LiveSession task?',
    },
    inputLiveSessionPriceLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.inputLiveSessionPriceLabel',
        defaultMessage: 'Price',
    },
    selectLiveSessionPriceCurrencyLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.selectLiveSessionPriceCurrencyLabel',
        defaultMessage: 'Currency',
    },
    inputLiveSessionCostLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.inputLiveSessionCostLabel',
        defaultMessage: 'Cost',
    },
    selectLiveSessionCostCurrencyLabel: {
        id: 'containers.AuditionScopePage.components.AddVersion.selectLiveSessionCostCurrencyLabel',
        defaultMessage: 'Currency',
    },
    liveSessionDatesFrom: {
        id: 'containers.AuditionScopePage.components.AddVersion.liveSessionDatesFrom',
        defaultMessage: 'From',
    },
    liveSessionDatesTo: {
        id: 'containers.AuditionScopePage.components.AddVersion.liveSessionDatesTo',
        defaultMessage: 'To',
    },
    liveSessionDatesMessage: {
        id: 'containers.AuditionScopePage.components.AddVersion.liveSessionDatesMessage',
        defaultMessage: 'Message',
    },
    liveSessionAddDate: {
        id: 'containers.AuditionScopePage.components.AddVersion.liveSessionAddDate',
        defaultMessage: '+ Add date',
    },
    cancel: {
        id: 'containers.AuditionScopePage.components.AddVersion.cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'containers.AuditionScopePage.components.AddVersion.save',
        defaultMessage: 'Save',
    },
    errorsPresent: {
        id: 'containers.AuditionScopePage.components.AddVersion.errorsPresent',
        defaultMessage: 'Must be filled out',
    },
    liveSessionDateDelete: {
        id: 'containers.AuditionScopePage.components.AddVersion.liveSessionDateDelete',
        defaultMessage: 'Delete',
    },
    loading: {
        id: 'containers.AuditionScopePage.components.AddVersion.loading',
        defaultMessage: 'Loading',
    },
    noData: {
        id: 'containers.AuditionScopePage.components.AddVersion.noData',
        defaultMessage: 'No dates added',
    }
})
